export default __webpack_public_path__ + "static/media/reviewCheckList.286daa3d.svg";